import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=94e046dc&scoped=true&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/featured.css?vue&type=style&index=0&id=94e046dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e046dc",
  null
  
)

export default component.exports